export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.29-1513.50",
  commitId: "9abc1a9d90966ebd63de864c1d342a65c2d0715f",
  commitTime: "2026-06-29T15:13:50.000Z",
});
